export default "__VITE_ASSET__DTfGvd3K__"